import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ── Suppress harmless "ResizeObserver loop" errors globally ──
// This error is benign and triggered by charting/map libraries (Recharts, Mapbox, etc.)
// It must be silenced at every level so React's error overlay never picks it up.

const isResizeObserverErr = (msg) =>
  typeof msg === 'string' && msg.includes('ResizeObserver loop');

// 1. window.onerror — classic global handler
const _origOnError = window.onerror;
window.onerror = (msg, ...args) => {
  if (isResizeObserverErr(msg)) return true;          // swallow
  return _origOnError ? _origOnError(msg, ...args) : false;
};

// 2. Capture-phase error event — fires BEFORE React's overlay listener
window.addEventListener('error', (e) => {
  if (e.message && isResizeObserverErr(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
}, true);

// 3. Bubble-phase error event — safety net
window.addEventListener('error', (e) => {
  if (e.message && isResizeObserverErr(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});

// 4. Unhandled rejection — some browsers surface it as a rejected promise
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && isResizeObserverErr(e.reason.message || String(e.reason))) {
    e.preventDefault();
  }
});
// ── End ResizeObserver suppression ──

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
